import BaseService from '../base';
import {
  SectionContractorsApiProps, JobApiProps, JobParamsProps,
  SectionDataProps,
} from './types';

class Section extends BaseService {
  getContractors() {
    return {
      query: (id: number) => ({
        url: `${this.url}/${id}/contractors-list`,
      }),
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      providesTags: (result?: SectionContractorsApiProps) => [{ type: this.tagType }],
    };
  }

  addJob() {
    return {
      query: ({ id, ...params }: JobParamsProps) => ({
        url: `${this.url}/${id}/jobs`,
        method: 'POST',
        body: params,
      }),
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      invalidatesTags: (result?: JobApiProps) => [{ type: this.tagType }],
    };
  }

  delete() {
    return {
      query: (id: number) => ({
        url: `/sections/${id}`,
        method: 'delete',
      }),
      invalidatesTags: [{ type: this.tagType, id: 'LIST' }, { type: 'Domains' }],
    };
  }

  update() {
    return {
      query: ({ id, ...params }: SectionDataProps) => ({
        url: `/sections/${id}`,
        method: 'PATCH',
        body: params,
      }),
      invalidatesTags: [{ type: this.tagType }, { type: 'Section' }, { type: 'Domains' }],
    };
  }
}

export default new Section('sections', 'Section');
